import { observer } from "mobx-react-lite";
import { Layer, Source } from "react-map-gl";
import { useMapStore } from "../..";
import { ILayerWithAbilityToOverrideIsStyleLoadedProps } from "../../interfaces/IlayerProps";

function SatelliteArcGISBaseMapLayer({ visible, isStyleLoadedOverride }: ILayerWithAbilityToOverrideIsStyleLoadedProps) {
    const mapStore = useMapStore();
    if (!(isStyleLoadedOverride ?? mapStore.isStyleLoaded))
        return null;

    return (
        <Source id="satelliteArcGISBaseMapSource" type="raster" tiles={[
            "https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}"
        ]} tileSize={256}>
            <Layer
                id="satelliteArcGISBaseMapLayer"
                type="raster"
                slot="top"
                beforeId="mapbox-satellite"
                layout={{
                    "visibility": visible ? "visible" : "none",
                }}
            />
        </Source>
    );
}

export default observer(SatelliteArcGISBaseMapLayer);